import React, { createContext, useContext, useState } from "react";
import { monthNames } from "../Helpers/globalFunctions";

// Create the context
const ComplaintFiltersContext = createContext(undefined);

// Provider component
export const ComplaintFiltersProvider = ({ children }) => {
  // Get current month for initial state
  const today = new Date();
  today.setMonth(today.getMonth());
  const previousMonth = monthNames[today.getMonth()];

  // Filter popup states
  const [filterPopup, setFilterPopup] = useState(false);
  const [filterTab, setFilterTab] = useState("Filter By Address");

  // Search state
  const [search, setSearch] = useState("");

  // Date filter states
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(previousMonth);

  // Deadline filter state
  const [deadlineDate, setDeadlineDate] = useState({
    startDate: "",
    endDate: "",
  });

  // Level data filter state
  const [selectedLevelDatas, setSelectedLevelDatas] = useState({});

  // Vendor filter state
  const [selectedVendor, setSelectedVendor] = useState(null);

  // Sector/Zone attribute filter state
  const [selectedSectorZoneAttribute, setSelectedSectorZoneAttribute] =
    useState(null);

  // Status tab state
  const [selectedStatusTab, setSelectedStatusTab] = useState(null);

  // Toggle states for my complaints and SOS complaints
  const [showMyComplaints, setShowMyComplaints] = useState(false);
  const [showSosComplaints, setShowSosComplaints] = useState(false);
  const [showEscalatedComplaints, setShowEscalatedComplaints] = useState(false);
  // Pagination state
  const [page, setPage] = useState(1);

  // Reset all filters function
  const resetAllFilters = () => {
    setSearch("");
    setStartDate("");
    setEndDate("");
    setSelectedMonth(previousMonth);
    setDeadlineDate({ startDate: "", endDate: "" });
    setSelectedLevelDatas({});
    setSelectedVendor(null);
    setSelectedSectorZoneAttribute(null);
    setSelectedStatusTab(null);
    setShowMyComplaints(false);
    setShowSosComplaints(false);
    setShowEscalatedComplaints(false);
    setPage(1);
    setFilterPopup(false);
    setFilterTab("Filter By Address");
  };

  // Reset pagination only
  const resetPage = () => {
    setPage(1);
  };

  const value = {
    // States
    filterPopup,
    filterTab,
    search,
    startDate,
    endDate,
    selectedMonth,
    deadlineDate,
    selectedLevelDatas,
    selectedVendor,
    selectedSectorZoneAttribute,
    selectedStatusTab,
    showMyComplaints,
    showSosComplaints,
    page,
    showEscalatedComplaints,
  

    // Setters
    setFilterPopup,
    setFilterTab,
    setSearch,
    setStartDate,
    setEndDate,
    setSelectedMonth,
    setDeadlineDate,
    setSelectedLevelDatas,
    setSelectedVendor,
    setSelectedSectorZoneAttribute,
    setSelectedStatusTab,
    setShowMyComplaints,
    setShowSosComplaints,
    setPage,
    setShowEscalatedComplaints,
    // Helper functions
    resetAllFilters,
    resetPage,
  };

  return (
    <ComplaintFiltersContext.Provider value={value}>
      {children}
    </ComplaintFiltersContext.Provider>
  );
};

// Custom hook to use the complaint filters context
export const useComplaintFilters = () => {
  const context = useContext(ComplaintFiltersContext);
  if (context === undefined) {
    throw new Error(
      "useComplaintFilters must be used within a ComplaintFiltersProvider"
    );
  }
  return context;
};
